export default {
  validateEmail (value) {
    let res = false
    if (value && value.length >= 5 && value.includes('@') && value.includes('.')) {
      res = true
    }
    return res
  },
  validatePhone (value) {
    let res = false
    if (value && value.length >= 9) {
      res = true
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/utils/dataHelper.js